export default function CalendarGrid({
    children,
}: {
    children: React.ReactNode;
}) {
    return (
        <>
            <div className=" alli-text-primary alli-mt-6 alli-grid alli-w-full alli-grid-cols-7 alli-gap-0 alli-text-center alli-text-xs/6 alli-font-medium">
                <div>Su</div>
                <div>Mo</div>
                <div>Tu</div>
                <div>We</div>
                <div>Th</div>
                <div>Fr</div>
                <div>Sa</div>
            </div>
            <div
                className={`alli-mt-2 alli-grid alli-grid-cols-7 alli-gap-0 alli-text-sm `}>
                {children}
            </div>
        </>
    );
}
